export class GetPageUtil {


  public getPageNumbers(
    currentPage: number,
    totalItemsCount: number,
    itemsPerPage: number,
  ): number[] {
    const maxPagesToShow = 5;
    const totalPages = Math.ceil(totalItemsCount / itemsPerPage);

    if (totalPages <= maxPagesToShow) {
      return Array.from({length: totalPages}, (_, i) => i + 1);
    }

    const half = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(0, currentPage - half);
    let endPage = Math.min(totalPages - 1, startPage + maxPagesToShow - 1);

    if (currentPage - half < 0) {
      endPage = Math.min(totalPages - 1, maxPagesToShow - 1);
    }
    if (currentPage + half >= totalPages) {
      startPage = Math.max(0, totalPages - maxPagesToShow);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i + 1);
    }

    return pages;
  }
}
